import { correlationId } from './correlationId';

type LogLevel = 'info' | 'warn' | 'error';

function send(level: LogLevel, message: string, stack?: string) {
    fetch('api/log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Correlation-ID': correlationId },
        body: JSON.stringify({ level, message, stack }),
    }).catch(() => {
        // ignore — don't log failures to avoid infinite loops
    });
}

const logger = {
    info: (message: string) => {
        console.info(message);
        send('info', message);
    },
    warn: (message: string) => {
        console.warn(message);
        send('warn', message);
    },
    error: (message: string, error?: unknown) => {
        console.error(message, error);
        const stack = error instanceof Error ? error.stack : undefined;
        send('error', message, stack);
    },
};

export default logger;
